// extracted by mini-css-extract-plugin
export var icon = "_7p-1";
export var subtext = "_7p-0";